import { render, staticRenderFns } from "./m-gc-step-accessories.vue?vue&type=template&id=4c71567a&scoped=true&"
import script from "./m-gc-step-accessories.vue?vue&type=script&lang=js&"
export * from "./m-gc-step-accessories.vue?vue&type=script&lang=js&"
import style0 from "./m-gc-step-accessories.vue?vue&type=style&index=0&id=4c71567a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c71567a",
  null
  
)

export default component.exports